import { fetchInstance } from '@/utils/fetchInstance.ts';

export interface AchievementProgress {
  current: number;
  max: number;
}

export interface AchievementReward {
  type: 'item' | 'pokeDollars';
  itemId?: number;
  quantity?: number;
  pokeDollars?: number;
}

export interface AchievementWithStatus {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  hidden: boolean;
  reward: AchievementReward;
  rewardLabel: string;
  unlocked: boolean;
  unlockedAt: string | null;
  progress: AchievementProgress | null;
}

export const getAchievements = (): Promise<AchievementWithStatus[]> =>
  fetchInstance.get<AchievementWithStatus[]>('achievements');
